export default "__VITE_ASSET__Bm53yEUP__"